module.exports = __webpack_public_path__ + "static/img/D’ici_2020.64c9781.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/looking-ahead/D’ici_2020.jpg
// module id = 092N
// module chunks = 0